import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import DataTable from "react-data-table-component";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { AiOutlineEye } from "react-icons/ai";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
const BillHeadList = () => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [RowId, SetRowId] = useState();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [search, SetSearch] = useState({
    search: "",
  });
  const [Datafilter, SetDatafilter] = useState([]);
  const [Data, SetData] = useState([]);
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get("/masters/billheads/");
      SetData(responce.data);
      setLoading(false);
      SetDatafilter(responce.data);
    } catch (error) {
      console.log(error);
    }
  };
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
    const response = Datafilter.filter(
      (data) =>
        (data.code && data.code.toLowerCase().includes(value.toLowerCase())) ||
        (data.name && data.name.toLowerCase().includes(value.toLowerCase())) ||
        (data.id && data.id.toString().includes(value))
    );
    console.log(response);
    SetData(response);
  };
  useEffect(() => {
    GetData();
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: (row, i) => i + 1,
      sortable: true,
    },
    {
      name: "id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "ACTIONS",
      selector: (row) => {
        const HandleEdit = async () => {
          return navigate(`/dashboard/masters/billhead/${row.id}/edit`);
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          console.log(id);
          await axiosConfig
            .delete(`/masters/billheads/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetData();
            })
            .catch((error) => {
              setDeletepopupType("error");
              console.log(error);
            });
        };
        const HandleView = () => {
          navigate(`/dashboard/masters/billhead/${row.id}/edit`);
        };
        return (
          <>
            <div className="row">
              <div className="col-4">
                <AiOutlineEye
                  className="dashboard-tabe-data-actions"
                  onClick={HandleView}
                />
              </div>
              <div className="col-4">
                <MdOutlineEdit
                  className="dashboard-tabe-data-actions"
                  onClick={HandleEdit}
                />
              </div>
              <div className="col-4">
                <MdDeleteOutline
                  className="dashboard-tabe-data-actions"
                  onClick={DeleteAlert}
                />
              </div>
            </div>
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <>
      <DashboardLayout>
        <div className="dashboard-header">
          <h5 className="dashboard-subtitle">View BillHead</h5>
          <NavLink to="/dashboard/masters/billhead/add">
            <button className="btn btn-white">Add New</button>
          </NavLink>
        </div>
        <div className="table-responsive">
          <DataTable
            columns={columns}
            data={Data}
            pagination
            draggableColumns
            fixedHeader
            customStyles={tableCustomStyles}
            subHeader
            progressPending={loading}
            progressComponent={
              <div className="loader-container">
                <img
                  src={require("../Components/FormParser/images/loader2.gif")}
                  alt="Loading..."
                />
              </div>
            }
            subHeaderComponent={
              <input
                type="text"
                className="form-control w-25"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            }
          />
        </div>
        {deletePopupType != "" && (
          <DeletePopupModal
            setDeletepopupType={setDeletepopupType}
            deletePopupType={deletePopupType}
          />
        )}
      </DashboardLayout>
    </>
  );
};
export { BillHeadList };
